// Зөвлөхийн порталын нийтлэг: огноо/цаг, үе шатын badge, уулзалтын мөр. API/кэш/аватар — багшийн порталаас.
import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { instance } from "utils/axios";
import { Avatar } from "modules/teacher/common";

export { errText, useCached, prefetch, Avatar, Refreshing } from "modules/teacher/common";
// noMessage: false — axios-ийн ерөнхий "Амжилттай" toast-гүй (хуудсууд өөрсдөө мэдэгдэнэ)
export const api = (method, url, data) => instance({ method, url, ...(method === "get" ? { params: data } : { data }), noMessage: false }).then((r) => r.data);

const WD = ["Ням", "Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба"];
export const dayLabel = (t) => { const m = moment(t); return `${WD[m.day()]}, ${m.month() + 1}-р сарын ${m.date()}`; };
export const timeRange = (t, min) => `${moment(t).format("HH:mm")}–${moment(t).add(min || 60, "minute").format("HH:mm")}`;
export const shortName = (u) => (u ? `${u.lastName?.[0] ? `${u.lastName[0]}. ` : ""}${u.firstName || ""}` : "");
export const typeLabel = (t) => (t === "online" ? "Онлайн · Google Meet" : t === "in_person" ? "Биечлэн" : "—");
export const sessionPath = (m) => `/c/session/${m.id}`;

export const STAGE = {
  requested: ["Хүсэлт", "tj-badge-accent"],
  upcoming: ["Удахгүй", "tj-badge-soft"],
  live: ["Явагдаж байна", "tj-badge-destructive"],
  done: ["Дууссан", "tj-badge-outline"],
  cancelled: ["Цуцалсан", "tj-badge-outline"],
};
export const StageBadge = ({ stage }) => { const [l, c] = STAGE[stage] || [stage, "tj-badge-outline"]; return <span className={`tj-badge ${c}`}>{l}</span>; };

export const Stars = ({ n, size = 14 }) => (
  <span className="inline-flex gap-0.5" aria-label={`${n} / 5 од`}>
    {[1, 2, 3, 4, 5].map((i) => <svg key={i} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" fill={i <= n ? "#f2cd30" : "none"} stroke={i <= n ? "#d4a514" : "#cbbfe0"} strokeWidth="2"><path d="M12 2l3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1z" /></svg>)}
  </span>
);

// Уулзалтын нэг мөр (жагсаалтад)
export function MeetingRow({ m, right }) {
  const s = m.student;
  return (
    <li className="flex items-center gap-3 py-3 border-b border-[#e5d8f5] last:border-0">
      <Avatar user={s} size={40} />
      <Link to={sessionPath(m)} className="flex flex-col min-w-0 flex-1 !text-[#1c1c1c] no-underline">
        <span className="text-sm font-bold truncate">{shortName(s)} <span className="font-medium tj-muted">· {s?.groupCode || `${s?.grade || ""}`}</span></span>
        <span className="text-[13px] tj-muted truncate">{m.topic || m.request || "Сэдэв бичээгүй"}</span>
      </Link>
      <span className="hidden sm:flex flex-col items-end text-right shrink-0">
        <span className="text-[13px] font-semibold">{dayLabel(m.startTime)}</span>
        <span className="text-xs tj-muted">{timeRange(m.startTime, m.durationMin)} · {m.type === "online" ? "Онлайн" : m.type === "in_person" ? "Биечлэн" : "—"}</span>
      </span>
      {right || <StageBadge stage={m.stage} />}
    </li>
  );
}

export const Empty = ({ children }) => <div className="text-sm tj-muted py-6 text-center">{children}</div>;
